export default __webpack_public_path__ + "static/media/image-artist-3.b0d1d9e9.jpg";